export default "__VITE_ASSET__e4e31687__"